var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-container"},[_c('a',{staticClass:"pdf",attrs:{"href":"/pdf/CSR Newsletter.pdf","aria-label":"CSR Newsletter link"}})])}]

export { render, staticRenderFns }